import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { OrdinalPipe } from './ordinal.pipe';

@Pipe({
    name: 'formalDate',
    standalone: false
})
export class FormalDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe, private ordinalPipe: OrdinalPipe) { }

  transform(dateTime: Date): any {
    const day = this.ordinalPipe.transform(dateTime.getDate());
    const date = this.datePipe.transform(dateTime, 'EEEE, MMMM');
    return `${date} ${day}`;
  }

}
